mutation createContactMessage($data: ContactMessageInput, $token: String) {
  createContactMessage(input: { data: $data, recaptchaToken: $token }) {
    message {
      id
      firstName
      lastName
      howDidYouHear
      message
      email
      phone
      ip
      cityInfo
      createdAt
      source
    }
  }
}
